import { isOffline as isRadioOffline } from '@/utils/networkStatus'
import { serverUnavailable } from '@/vendor/serverAvailability'

// The single connectivity signal: are we able to reach the server right now?
// Three inputs collapse into it — the phone has a connection, the user hasn't
// forced offline mode, and the server is answering. When it is false, nothing
// should retry against the network: reads serve offline data and writes queue,
// until the recovery poller (serverAvailability) restores server access.
//
// Forced-offline is mirrored here from the preferences store so link/fetch code
// can read connectivity synchronously without a pinia dependency or import cycle.
let forcedOffline = false

export function setForcedOffline(value: boolean): void {
  forcedOffline = value
}

export function isConnected(): boolean {
  return !isRadioOffline() && !forcedOffline && !serverUnavailable.value
}
